/******************************************************************************
 * Created Date: Tuesday January 25th 2022                                    *
 * Author: Patrick B.                                                         *
 * -----                                                                      *
 * Last Modified: Wed Feb 02 2022                                             *
 * Modified By: Patrick B.                                                    *
 * -----                                                                      *
 * File: /src/components/common/dialogs/SliderSearchTimeDialog.js             *
 * Copyright (c) 2022 Kuva                                                    *
 ******************************************************************************/

import { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { TextField, Popover, Grid, Typography } from "@mui/material";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";

const filterOptions = createFilterOptions({
  matchFrom: "start",
  stringify: option => option.value
});

const SliderSearchTimeDialog = ({
  open,
  handleClose,
  anchorEl,
  scanIndex,
  setScanIndex,
  scanResults,
  unnormalizeTime,
  normalizeTime
}) => {
  const options = useMemo(() => {
    return scanResults.map((scres, index) => {
      return {
        value: unnormalizeTime(normalizeTime(scres.createdOn)),
        index
      };
    });
  }, [scanResults]);

  const [input, setInput] = useState("");
  const [selected, setSelected] = useState(options[scanIndex]);

  const handleSelectedChange = (event, newValue) => {
    if (newValue) {
      setScanIndex(newValue.index);
    }
  };

  const handleInputChange = (event, newValue) => {
    setInput(newValue);
  };

  useEffect(() => {
    setSelected(options[scanIndex]);
  }, [scanIndex, options]);

  return (
    <Popover open={open} onClose={handleClose} anchorEl={anchorEl}>
      <Grid
        container
        spacing={1}
        alignContent="space-between"
        style={{
          margin: 5
        }}
      >
        <Autocomplete
          disableClearable
          value={selected}
          onChange={handleSelectedChange}
          inputValue={input}
          onInputChange={handleInputChange}
          id="slider-search-dialog"
          options={options}
          getOptionLabel={option => option.value}
          filterOptions={filterOptions}
          style={{ padding: "9px" }}
          renderInput={params => {
            return (
              <TextField
                variant="standard"
                {...params}
                label={
                  <Typography variant="caption" style={{ fontSize: 15 }}>
                    TIME
                  </Typography>
                }
              />
            );
          }}
          ListboxProps={{
            style: { maxHeight: "200px" }
          }}
        />
      </Grid>
    </Popover>
  );
};

SliderSearchTimeDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  anchorEl: PropTypes.object,
  scanIndex: PropTypes.number.isRequired,
  setScanIndex: PropTypes.func.isRequired,
  scanResults: PropTypes.array.isRequired,
  unnormalizeTime: PropTypes.func.isRequired,
  normalizeTime: PropTypes.func.isRequired
};

export default SliderSearchTimeDialog;
